import { ReactNode } from 'react';

import { useClasses } from '@kanda-libs/ks-design-library';

import CheckListElementsItem from './CheckListElementsItem';
import { CLASS_NAMES } from './constants';

export type CheckListItem = ReactNode;

export interface CheckListElementProps {
  isLoading?: boolean;
  className?: string;
  items: CheckListItem[];
}

const CheckListElement: React.FunctionComponent<CheckListElementProps> =
  function ({ items, className, isLoading = false }) {
    const classNames = useClasses(CLASS_NAMES, {
      container: ['.container', className],
    });
    return (
      <div className={classNames.container}>
        {items.map((elements, index) => {
          const key = `element-${index}`;
          return (
            <CheckListElementsItem
              key={key}
              element={elements}
              isLoading={isLoading}
            />
          );
        })}
      </div>
    );
  };

export default CheckListElement;
